import { dispatch } from './dispatcher-accumulator';
export const apiCall = (ep, success, failure) => fetch(ep).then(res => res.json()).then(data => success && dispatch(success(data))).catch(err => failure && dispatch(failure(err)));